import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class DispatchEquipmentAdjustmentBus extends BaseBus {
    constructor(busObj: DispatchEquipmentAdjustmentBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.dispatchEquipmentAdjustmentId;
    }
    setId(id: any) {
        this.dispatchEquipmentAdjustmentId;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    initialize(data: DispatchEquipmentAdjustmentBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    dispatchEquipmentAdjustmentId: any;
    dispatchEquipmentAdjustmentCodeId: any;
    dispatchId: any;
    personId: any;
    saleAmount: number;
    costAmount: number;
    note: string;
    recognitionDt: Date;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    dispatchEquipmentAdjustmentCode: string;
}
